<template>
  <div class="container row rounded-3 bg-secondary mb-5 py-3 px-5">

    <form id="jwtForm" action="https://visualcrossing.zendesk.com/access/jwt" method="POST">
      <input id="jwtInput" type="hidden" name="jwt" />

    </form>


    <div class="col-12 col-md-6">
      <div v-if="!hasSession" class="alert alert-primary my-3" role="alert">
        <i class="bi bi-lock"></i>You aren't signed into an account. Please <a href="#signinModal" data-bs-toggle="modal">sign in</a> to access account information.
      </div>

      <div class="mb-3">
        <div>Vc Session Id</div>
        <div>{{sessionId}}</div>
      </div>

      <div class="mb-3">
        <div>Zendesk Session Id</div>
        <div>{{zendeskSessionId}}</div>
      </div>

      <div class="mb-3 row">
        <button @click="createZendeskToken" :class="{disabled:!hasSession}" class="btn btn-sm text-primary col-3">Refresh Zendesk Session</button>
        <button @click="submitToZendesk" :class="{disabled:!zendeskSessionId}" class="btn btn-sm text-primary col-3">Submit to zendesk</button>
      </div>

    </div>
  </div>
</template>a

<script>
import "/src/visualcrossing-core/vccommunicator_account";
import '/src/website-core/VcUtils'

export default {
  name: 'ZendeskRedirect',
  props: {
    
  },
  emits: [],
  data() {
    return {
      sessionId:null,
      sessionState:null,
      zendeskSessionId:null,
      error:null,
    }
  },
  methods:{
    submitToZendesk() {
      let me=this;
      document.getElementById('jwtInput').value =me.zendeskSessionId;
      document.forms['jwtForm'].submit();
    },  
    createZendeskToken() {
      let me=this;

      vcCommunicator.createZendeskSsoToken()
        .then(function (result) {
          me.zendeskSessionId=result.token;
        }).catch((error) => {
          
          console.log("Failed requestValidation:"+error);
          me.zendeskSessionId=error;
          me.error=error;
          
          
        });
    }
  },
  computed:{
    hasSession() {
      return this.sessionId;
    }
  },
  watch: {
   
  },
  mounted() {
    let me=this;
    var vcCommunicator=window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
    me.sessionId=vcCommunicator.sessionId;
    me.sessionState=vcCommunicator.sessionState;
    vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
      me.sessionId=sessionId;
      me.sessionState=sessionState;
     
      
    });
     vcCommunicator.addHandler('terminatesession', function () {
       me.sessionId=null;
    });
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>